module.exports = __webpack_public_path__ + "img/banner.22f750a9.png";